module.exports = __webpack_public_path__ + "static/img/6.11574bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/sp/6.png
// module id = 3qKN
// module chunks = 0